import {axios} from "~/plugins/axios";
import moment from "moment";

const getDefaultState_GraphQl = () => {
  return {
    dashboards: [],
    dashboard: {},
    editedWidgetId: '',
  }
}
const state = getDefaultState_GraphQl();

const getters = {
  dashboards: state => state.dashboards,
  dashboard: state => state.dashboard,
  editedWidgetId: state => state.editedWidgetId,
}

const actions = {
  async loadMetrics(state, { projectId, period }) {
    return axios.get(`/api/projects/${projectId}/auto-complaints/get-correctness-metrics`, {
      params: {
        period: period,
      }
    })
      .then(resp => resp.data);
  },
}

const mutations = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}